import * as React from 'react';
import gql from 'graphql-tag';
import { ChildProps, graphql } from 'react-apollo';
import { ImageAdCreativeFragment, AdFragment } from '../../cms/components/cms_listings_collection';
import { CoreAdImageFeature } from '../../rql';
import { AdImageFeature } from './ad_image_feature';

interface ExternalProps {
  categoryUuids: string[];
}
type Props = ChildProps<ExternalProps, CoreAdImageFeature.Query>;

const AD_ZONE = 'category-feature';

const query = gql`
  query Core_Ad_Image_Feature(
    $categories: [String]
    $adZone: String
  ) {
    adServe(input: {
      targeting: {
        categories: $categories
      },
      placements: [{adZones: {slug: $adZone}, adTypes: {format: IMAGE_AD}}]
    }) {
      placements {
        adZones {
          slug
        }
        ad {
          ...AdData
          imageAdCreative {
            ...ImageAdCreativeData
          }
        }
      }
    }
  }
  ${AdFragment}
  ${ImageAdCreativeFragment}
`;

const bannerQuery = graphql<Props, CoreAdImageFeature.Query, CoreAdImageFeature.Variables>(query,
  {
    options: (ownProps) => {
      return {
        variables: {
          categories: ownProps.categoryUuids,
          adZone: AD_ZONE,
        },
      };
    },
  },
);

export function AdFeatureContainer(props: Props) {
  const hasData = (!props.data?.loading && !!props.data?.adServe?.placements[0]?.ad?.imageAdCreative);

  if (!hasData) {
    return null;
  }

  return (
    <AdImageFeature
      ad={props.data?.adServe?.placements[0]?.ad}
      adZones={props.data?.adServe?.placements[0]?.adZones}
    />
  );
}

export default (bannerQuery(AdFeatureContainer));



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/commons/src/components/ads/ad_image_feature_container.tsx